import * as React from "react";
import styles from "./ForgetPass.module.css";

import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, styled, ThemeProvider } from "@mui/material/styles";
import logo from "../../Assets/logo.webp";
import Parse from "../../API/ParseServer";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
function Copyright(props: any) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="/">
        Faam Gallery
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();
const CssTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: "#863a18",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#863a18",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#863a18",
    },
    "&:hover fieldset": {
      borderColor: "#863a18",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#863a18",
    },
  },
});

export default function ForgetPass() {
  const [isLLogedIn, setIsloggedIn] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const navigate = useNavigate();
  const [codeVal, setCodeVal] = React.useState<String | null>(null);
  const codeVhangeHandler = (event: any) => {
    setCodeVal(event.target.value);
  };
  useEffect(() => {
    const currentUser = Parse.User.current();
    if (currentUser) {
      console.log("User is logged in:", currentUser);
      setIsloggedIn(true);
      setErrorMessage("You are already logged in");
    } else {
      console.log("No user is logged in.");
      setErrorMessage("");
    }
  }, []);
  const [pageStatus, setPageStatus] = React.useState("ver");
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const email = String(data.get("email"));
    const password = String(data.get("password"));
    const code = String(data.get("verification-code"));
    const confirmPassword = String(data.get("confirm-password"));
    const validEmail =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (pageStatus === "ver") {
      if (!email) setErrorMessage("Please enter your email.");
      else if (!validEmail.test(String(email)))
        setErrorMessage("Email address format is invalid.");
      else {
        setErrorMessage("");
        try {
          await Parse.Cloud.run("sendVerificationCode", { email });
          localStorage.setItem("email", email);
          setCodeVal("");
          setPageStatus("res");
        } catch (error: any) {
          console.log(error.message);
          setErrorMessage("User not found.");
        }
      }
    } else {
      if (!(code && password && confirmPassword))
        setErrorMessage("Please enter verification code and new password.");
      else if (!(password === confirmPassword))
        setErrorMessage("Passwords are not the same.");
      else {
        setErrorMessage("");
        try {
          await Parse.Cloud.run("resetPasswordWithCode", {
            email: localStorage.getItem("email"),
            code,
            newPassword: password,
          });
          console.log("Password reset successfully!");
          navigate("/login");
          localStorage.removeItem("email");
        } catch (error: any) {
          console.log(error.message);
          setErrorMessage("Invalid or expired verification code.");
        }
      }
    }
  };

  const logoutHandler = () => {
    Parse.User.logOut();
    window.location.reload();
  };
  return (
    <ThemeProvider theme={defaultTheme}>
      <Container
        component="main"
        maxWidth="xs"
        sx={{ height: "calc(100vh - 6rem)" }}
      >
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Link href="/">
            <img src={logo} alt="Faam Gallery" className={styles.logo} />
          </Link>
          {isLLogedIn ? (
            <React.Fragment>
              <Typography sx={{ color: "#863a18", mb: 3 }}>
                {errorMessage}
              </Typography>
              <Link href="/" color={"#863a18"}>
                home page
              </Link>
              <button
                style={{
                  background: "transparent",
                  border: "none",
                  outline: "none",
                  color: "#863a18",
                  cursor: "pointer",
                }}
                onClick={logoutHandler}
              >
                log out
              </button>
            </React.Fragment>
          ) : pageStatus === "res" ? (
            <React.Fragment>
              <Typography component="h1" variant="h5">
                Reset Password
              </Typography>

              <Box
                component="form"
                noValidate
                onSubmit={handleSubmit}
                sx={{ mt: 3 }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <CssTextField
                      required
                      fullWidth
                      id="verification-code"
                      label="Verificarion Code"
                      name="verification-code"
                      autoComplete="verification-code"
                      value={codeVal}
                      defaultValue={codeVal}
                      onChange={codeVhangeHandler}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <CssTextField
                      required
                      fullWidth
                      name="password"
                      label="Password"
                      type="password"
                      id="password"
                      autoComplete="new-password"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <CssTextField
                      required
                      fullWidth
                      name="confirm-password"
                      label="Confirm Password"
                      type="password"
                      id="confirm-password"
                      autoComplete="new-password"
                    />
                  </Grid>
                </Grid>
                <button className={styles.button}>Reset Password</button>
                {errorMessage && (
                  <Typography
                    sx={{
                      textAlign: "center",
                      my: 2,
                      color: "#862e18",
                      fontWeight: "bold",
                    }}
                  >
                    {errorMessage}
                  </Typography>
                )}
              </Box>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Typography component="h1" variant="h5">
                Reset Password
              </Typography>

              <Box
                component="form"
                noValidate
                onSubmit={handleSubmit}
                sx={{ mt: 3 }}
              >
                <Grid container>
                  <Grid item xs={12}>
                    <CssTextField
                      required
                      fullWidth
                      id="email"
                      label="Email Address"
                      name="email"
                      autoComplete="email"
                      sx={{ width: "22rem" }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    {/* <CssTextField
                      required
                      fullWidth
                      id="email"
                      label="Email Address"
                      name="email"
                      autoComplete="email"
                    /> */}
                  </Grid>
                  {/* <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox value="allowExtraEmails" color="primary" />
                  }
                  label="I want to receive inspiration, marketing promotions and updates via email."
                />
              </Grid> */}
                </Grid>
                <button className={styles.button}>
                  Send Verification Code
                </button>
                {errorMessage && (
                  <Typography
                    sx={{
                      textAlign: "center",
                      my: 2,
                      color: "#862e18",
                      fontWeight: "bold",
                    }}
                  >
                    {errorMessage}
                  </Typography>
                )}
                {/* <Grid container justifyContent="center">
                  <Grid item>
                    <Link href="/signup" variant="body2" color={"#863a18"}>
                      Don't have an account? Sign Up
                    </Link>
                  </Grid>
                </Grid> */}
              </Box>
            </React.Fragment>
          )}
        </Box>
        <Copyright sx={{ mt: 5 }} />
      </Container>
    </ThemeProvider>
  );
}
